import { useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Login } from './components/Login'
import { CreatePatient } from './components/CreatePatient'
import { MainScreen } from './components/MainScreen'
import { BPApi } from './services/api'
import { LanguageProvider } from './contexts/LanguageContext'

const api = new BPApi()
const basename = '/pressure'

function App() {
  const [patientId, setPatientId] = useState<string | null>(null)

  const handleLogout = () => {
    setPatientId(null)
  }

  return (
    <LanguageProvider>
      <Router basename={basename}>
        <Routes>
          <Route 
            path="/" 
            element={
              patientId ? (
                <Navigate to="/main" replace />
              ) : (
                <Login onLogin={setPatientId} api={api} />
              )
            } 
          />
          <Route 
            path="/create" 
            element={
              patientId ? (
                <Navigate to="/main" replace />
              ) : (
                <CreatePatient onLogin={setPatientId} api={api} />
              )
            } 
          />
          <Route 
            path="/main" 
            element={
              patientId ? (
                <MainScreen patientId={patientId} onLogout={handleLogout} api={api} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
        </Routes>
      </Router>
    </LanguageProvider>
  )
}

export default App
